/* ==========================================================================
   PrettyRobes — Bridal Clutch Bags collection section
   Scoped to .bc-page so listeners cannot collide with Dawn / pr-product1.js
   ========================================================================== */
(function () {
  'use strict';

  function init(root) {
    if (!root) return;

    // Smooth-scroll for in-page anchors with sticky-header offset (matches mockup behaviour)
    root.querySelectorAll('a[href^="#"]').forEach(function (a) {
      var href = a.getAttribute('href');
      if (!href || href === '#' || href.length < 2) return;
      a.addEventListener('click', function (e) {
        var t = document.getElementById(href.slice(1));
        if (!t) return;
        e.preventDefault();
        var hdr = document.querySelector('.pr-hdr');
        var off = (hdr ? hdr.offsetHeight : 0) + 12;
        window.scrollTo({ top: t.getBoundingClientRect().top + window.scrollY - off, behavior: 'smooth' });
      });
    });

    // Filter chips — visual toggle only; "All" resets, others toggle
    var chips = root.querySelectorAll('.bc-chip');
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        var isAll = (c.textContent || '').trim().toLowerCase().indexOf('all') === 0;
        if (isAll) {
          chips.forEach(function (x) { x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); });
        } else {
          var allChip = chips[0];
          if (allChip) allChip.setAttribute('aria-pressed', 'false');
          c.setAttribute('aria-pressed', c.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
        }
      });
    });

    // Sort select — submits the surrounding form on change so Shopify can
    // re-render with ?sort_by=...
    var sortSelect = root.querySelector('.bc-sort select');
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        var form = sortSelect.closest('form');
        if (form) form.submit();
      });
    }

    // Load More — AJAX append next page of products in place.
    // Falls back to a normal navigation (with #vitrine anchor) on error.
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('.bc-loadmore .bc-cta[data-loadmore]');
      if (!btn) return;
      var url = btn.getAttribute('href');
      if (!url || url.charAt(0) === '#') return;
      e.preventDefault();

      if (btn.getAttribute('aria-busy') === 'true') return;
      btn.setAttribute('aria-busy', 'true');
      btn.style.pointerEvents = 'none';
      var origHTML = btn.innerHTML;
      btn.innerHTML = 'Loading…';

      fetch(url, { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('Network error');
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var grid = root.querySelector('.bc-prods');
          var newProds = doc.querySelectorAll('.bc-prods > .bc-prod');
          if (!grid || newProds.length === 0) throw new Error('No products parsed');

          var loadmoreEl = btn.closest('.bc-loadmore');
          var firstNew = null;
          newProds.forEach(function (p, i) {
            grid.appendChild(p);
            if (i === 0) firstNew = p;
          });

          var newLoadmore = doc.querySelector('.bc-loadmore');
          if (loadmoreEl) {
            if (newLoadmore) loadmoreEl.replaceWith(newLoadmore);
            else loadmoreEl.remove();
          }

          if (firstNew && typeof firstNew.scrollIntoView === 'function') {
            firstNew.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        })
        .catch(function () {
          // Restore button state, then fall back to a normal navigation so the
          // user still gets the next page (browser will honor the #vitrine anchor).
          btn.innerHTML = origHTML;
          btn.removeAttribute('aria-busy');
          btn.style.pointerEvents = '';
          window.location.href = url;
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('.bc-page').forEach(init);
    });
  } else {
    document.querySelectorAll('.bc-page').forEach(init);
  }
})();
